import React from 'react'
import CIcon from '@coreui/icons-react'
import { cilSpeedometer } from '@coreui/icons'
import { CNavItem, CNavTitle, CNavGroup } from '@coreui/react'
import withTokenValidation from './withTokenValidation'

const _nav = [
  {
    component: withTokenValidation(CNavItem),
    name: 'Dashboard',
    to: '/dashboard',
    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
    // badge: {
    //   color: 'info',
    //   text: 'NEW',
    // },
  },
  {
    component: withTokenValidation(CNavItem),
    name: 'Users',
    to: '/users',
    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
  },
  {
    component: withTokenValidation(CNavItem),
    name: 'Houses',
    to: '/houses',
    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
  },
  {
    component: withTokenValidation(CNavItem),
    name: 'Matches',
    to: '/Matches',
    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
  },
  {
    component: withTokenValidation(CNavItem),
    name: 'Challenges',
    to: '/challenges',
    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
  },
  {
    component: withTokenValidation(CNavItem),
    name: 'Inappropriate Responses',
    to: '/challenges/inappropriate/responses',
    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
  },
  {
    component: withTokenValidation(CNavItem),
    name: 'Messages',
    to: '/messages',
    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
  },
  {
    component: withTokenValidation(CNavItem),
    name: 'Inappropriate Messages',
    to: '/messages/inappropriate',
    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
  },
  {
    component: withTokenValidation(CNavGroup),
    name: 'Urgent Cases',
    // to: '/urgent_cases',
    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
    items: [
      {
        component: withTokenValidation(CNavItem),
        name: 'Cases',
        to: '/cases',
      },
      {
        component: withTokenValidation(CNavItem),
        name: 'Key Words',
        to: '/keywords',
      },
    ],
  },
  {
    component: withTokenValidation(CNavItem),
    name: 'Mood Rings',
    to: '/moodrings',
    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
  },
  {
    component: withTokenValidation(CNavItem),
    name: 'Send Push Notifications',
    to: '/notifications/send',
    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
  },
  {
    component: withTokenValidation(CNavItem),
    name: 'Prizes',
    to: '/Prizes',
    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
  },
  {
    component: withTokenValidation(CNavItem),
    name: 'Claims',
    to: '/Claims',
    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
  }
]

export default _nav
